var map = {
	"./arrow-dot-white.svg": 61,
	"./arrow-dot.svg": 62,
	"./arrow-solid-hover.svg": 63,
	"./arrow-solid.svg": 64,
	"./arrow-up.svg": 65,
	"./bell.svg": 66,
	"./calendar.svg": 67,
	"./chat-bot.svg": 68,
	"./clock-hover.svg": 69,
	"./clock.svg": 70,
	"./close.svg": 71,
	"./dotted.svg": 72,
	"./file.svg": 73,
	"./folder.svg": 74,
	"./lap.svg": 75,
	"./light-bulb.svg": 76,
	"./light.svg": 77,
	"./logo.svg": 31,
	"./logout.svg": 78,
	"./mail.svg": 79,
	"./more.svg": 80,
	"./new.svg": 81,
	"./other.svg": 82,
	"./people.svg": 83,
	"./projectors.svg": 84,
	"./star.svg": 85,
	"./task.svg": 86,
	"./tick.svg": 87,
	"./time.svg": 88,
	"./umbrella.svg": 89,
	"./weather-1.svg": 90,
	"./weather-2.svg": 91,
	"./weather-3.svg": 92,
	"./weather-4.svg": 93,
	"./weather-5.svg": 94,
	"./weather.svg": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;